<ng-container *ngIf="!item.hidden && item.role == user && isItemVisibleByPermission(item) && isContactPortalGroupFilterVisible(item) && isQuotationGatedItemVisible(item) && isItemVisibleOnViewport(item)">
    <li [ngClass]="item.classes" *ngIf="item.url && !item.external" [routerLinkActive]="['active']">
      <a class="nav-link" [target]="item.target ? '_blank' : '_self'" [routerLink]="[item.url]" (click)="closeOtherMenu($event)" [attr.title]="showTitle ? (item.title | translate) : null">
        <span class="nav-item-wrapper">
          <span *ngIf="item.icon" class="pcoded-micon">
            <i-feather [name]="item.icon"></i-feather>
          </span>
          <span class="pcoded-mtext" *ngIf="item.icon; else directTitle">{{item.title | translate}}</span>
          <ng-template #directTitle>
            {{ item.title | translate }}
          </ng-template>
          <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
        </span>
      </a>
    </li>
    <li [ngClass]="item.classes" *ngIf="item.url && item.external">
      <a [target]="item.target ? '_blank' : '_self'" [href]="item.url" [attr.title]="showTitle ? (item.title | translate) : null">
        <span class="nav-item-wrapper">
          <span *ngIf="item.icon" class="pcoded-micon">
            <i-feather [name]="item.icon"></i-feather>
          </span>
          <span class="pcoded-mtext" *ngIf="item.icon; else directTitle">{{ item.title | translate }}</span>
          <ng-template #directTitle>
            {{ item.title | translate }}
          </ng-template>
          <ng-container *ngTemplateOutlet="itemBadge"></ng-container>
        </span>
      </a>
    </li>
    <ng-template #itemBadge>
      <span *ngIf="item.badge && themeLayout === 'vertical'" class="pcoded-badge label" [ngClass]="item.badge.type">
        {{item.badge.title | translate}}
      </span>
      <span *ngIf="item.badge && themeLayout === 'horizontal'" class="badge label" [ngClass]="item.badge.type">
        {{ item.badge.title | translate }}
      </span>
    </ng-template>
  </ng-container>
  